// Client-side SMS helpers for the admin Send-SMS screen: recipient parsing and
// GSM-7 segment counting, used for the live counter and the confirm/cost preview.
// Mirrors auth-service/utils/sms-helpers.js — the backend re-validates on send.

const GSM7_BASIC =
    "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ ÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?" +
    "¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
const GSM7_EXTENDED = "^{}\\[~]|€";

function isGsm7(message) {
    for (const ch of message) {
        if (GSM7_BASIC.indexOf(ch) === -1 && GSM7_EXTENDED.indexOf(ch) === -1) return false;
    }
    return true;
}

export function smsSegments(message = "") {
    const msg = message || "";
    const gsm = isGsm7(msg);
    let length = 0;
    if (gsm) {
        for (const ch of msg) length += GSM7_EXTENDED.indexOf(ch) !== -1 ? 2 : 1;
    } else {
        length = [...msg].length;
    }
    const single = gsm ? 160 : 70;
    const multi = gsm ? 153 : 67;
    const segments = length === 0 ? 0 : length <= single ? 1 : Math.ceil(length / multi);
    const perSegment = length <= single ? single : multi;
    return { encoding: gsm ? "GSM-7" : "UCS-2", unicode: !gsm, length, segments, perSegment };
}

export function normalizeGhanaNumber(raw) {
    if (raw == null) return null;
    let digits = String(raw).trim().replace(/[^\d+]/g, "").replace(/^\+/, "");
    if (digits.startsWith("233")) digits = "0" + digits.slice(3);
    else if (digits.length === 9 && /^[235]/.test(digits)) digits = "0" + digits;
    return /^0[235]\d{8}$/.test(digits) ? digits : null;
}

// Accepts raw text (commas / spaces / newlines / CSV cells) or an array.
// Returns { valid, invalid, duplicates, total }.
export function parseRecipients(input) {
    const tokens = Array.isArray(input) ? input : String(input || "").split(/[\s,;]+/);
    const valid = [];
    const invalid = [];
    const seen = new Set();
    let duplicates = 0;
    for (const tok of tokens) {
        const t = String(tok).trim();
        if (!t) continue;
        const num = normalizeGhanaNumber(t);
        if (!num) { invalid.push(t); continue; }
        if (seen.has(num)) { duplicates++; continue; }
        seen.add(num);
        valid.push(num);
    }
    return { valid, invalid, duplicates, total: valid.length };
}

export const MAX_RECIPIENTS = 1000;
